<template>
    <section class="features-area section-padding pt-100 fix section" id="feature">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="section-title text-center">
                        <div class="title-icon"></div>
                        <h2 class="title">WHAT ARE THE GOALS OF RHINOCAM.ORG</h2>
                        <p class="paragraph">Through education, awareness and support we hope to make a difference in the fight against rhino poaching</p>
                    </div>
                </div>
            </div>
            <div class="row feature-item-inner">
                <!-- feature single item start -->
                <div v-for="(feature, features) in features" :key="features" class="col-lg-4 col-md-6">
                    <div class="feature-item">
                        <div class="feature-icon">
                            <i :class="feature.icon"></i>
                        </div>
                        <div class="feature-content">
                            <h6>{{ feature.title }}</h6>
                            <p>{{ feature.desc }}</p>
                        </div>
                    </div>
                </div>
                <!-- feature single item start -->
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'Features',
    components: {
    },
    data () {
        return {
            features: [
                {
                    title:"AWARENESS", 
                    desc:"Watch the live rhino cams to see first hand the animals that are being affected by this crisis.", 
                    icon:"fa fa-users"
                },
                {
                    title:"CONSERVATION", 
                    desc:"Learn how Care For Wild cares for these animals through their rescue, rehabilitate and rewild program", 
                    icon:"fa fa-paw"
                },
                {
                    title:"SUPPORT", 
                    desc:"Help make a difference by donating directly to the care of the orphaned rhinos", 
                    icon:"fa fa-medkit"
                
            
                },
            ]
        }
    }
}
</script>

<style lang='scss'>
    @import '../assets/scss/variables.scss';
    @import '../assets/scss/components/feature.scss';
</style>
